import type {SlotGameStore} from "@gamzix/slot_core";
import {BonusGameComponent} from "../../bonusGame/src";

class WinFramesComponent extends Game.src.component.BaseComponent {
    protected reels = [];
    protected symbolHeight: number;

    public onGameReady() {
        super.onGameReady();

        game.on(ReelsetComponent.events.SHOW_ALL_LINES, this.showAllLinesFrames.bind(this));
        game.on('BigWinComponent.START_BIG_WIN', this.showAllLinesFrames.bind(this));
        game.on(ReelsetComponent.events.SHOW_LINE, ({positions}) => this.addSymbolFrame(positions));
        game.on("ReelsetComponent.SHOW_BONUS_SYMBOLS_WIN", ({positions}) => this.addSymbolFrame(positions));
        //@ts-ignore
        game.on(BonusGameComponent.events.START_INTRO_POPUP, this.onStartIntroPopup.bind(this));
        for(let i = 0; i < (<any>game.component.reelset).column; i++){
            this.reels.push(game.tree.findByName(`reel_${i}`))
        }
        this.symbolHeight = game.component.reelset.options.config.gameMode.main.symbolHeight;
    }

    protected async onStartIntroPopup(){
        await game.utils.delay(500);
        this.removeChildren();
    }

    showAllLinesFrames(): void{
        const lines = [...this.store.gameData.lines, ...this.store.gameData.ways, ...this.store.gameData.positions];
        let positions: number[][] = [];

        for (let i = 0; i < lines.length; i++) {
            const line = lines[i];
            line.positions.forEach(([x, y]) => {
                if (!positions.find(([_x, _y]) => _x === x && _y === y)) {
                    positions.push([x, y])
                }
            });
        }
        this.addSymbolFrame(positions);
    }

    protected addSymbolFrame(positions: number[][]): void{
        this.removeChildren();
        positions.forEach(([x, y]) => {
            const frame = <any>game.builder.create(<any>{
                type: "Spine",
                spine: "symbol_frame",
                animation: "winframe",
                loop: true,
                position: this.getFramesymbolPosition(x, y),
            })

            this.view.addChild(frame)
        })
    }

    protected getFramesymbolPosition(x: number, y: number): {x: number, y: number}{
        return {x: this.reels[x].position.x, y: this.reels[x].position.y + this.symbolHeight * (y - 1) - 200}
    }

    protected removeChildren(): void{
        game.utils.PIXIUtils.removeAllChildren(this.view);
    }

    getFSMHandlers() {
        return {
            IDLE: {
                enter: {
                    on: this.removeChildren.bind(this)
                }
            }
        };
    }

    get store(): SlotGameStore {
        return <SlotGameStore>game.store
    }
}

//@ts-ignore
Game.src.component.WinFramesComponent = WinFramesComponent;